import React from 'react'
import Dashboard from '../../Screens/OrganisationAdmin/Dashboard'
import CreateUsers from '../../Screens/OrganisationAdmin/CreateUsers'
import ManageUsers from '../../Screens/OrganisationAdmin/ManageUsers'
import AccessLogs from '../../Screens/OrganisationAdmin/AccessLogs'
import AddProducts from '../../Screens/OrganisationAdmin/AddProducts'
import ManageProducts from '../../Screens/OrganisationAdmin/ManageProducts'
import PrintBarcodes from '../../Screens/OrganisationAdmin/PrintBarcodes'
import ImportFromExcel from '../../Screens/OrganisationAdmin/ImportFromExcel'
import NewStockEntry from '../../Screens/OrganisationAdmin/NewStockEntry'
import ManageStocks from '../../Screens/OrganisationAdmin/ManageStocks'
import StockAdjustments from '../../Screens/OrganisationAdmin/StockAdjustments'
import StockMovement from '../../Screens/OrganisationAdmin/StockMovement'
import StockMovementDetail from '../../Screens/OrganisationAdmin/StockMovementDetail'
import ReturntoWarehouse from '../../Screens/OrganisationAdmin/ReturntoWarehouse'
import TransferStocks from '../../Screens/OrganisationAdmin/TransferStocks'
import LowStock from '../../Screens/OrganisationAdmin/LowStock'
import AddCategories from '../../Screens/OrganisationAdmin/AddCategories'
import ManageCategories from '../../Screens/OrganisationAdmin/ManageCategories'
import AddUnit from '../../Screens/OrganisationAdmin/AddUnit'
import ManageUnits from '../../Screens/OrganisationAdmin/ManageUnits'
import AddBranch from '../../Screens/OrganisationAdmin/AddBranch'
import ManageBranches from '../../Screens/OrganisationAdmin/ManageBranches'
import BranchStock from '../../Screens/OrganisationAdmin/BranchStock'
import AddWarehouse from '../../Screens/OrganisationAdmin/AddWarehouse'
import ManageWarehouses from '../../Screens/OrganisationAdmin/ManageWarehouses'
import AddExpense from '../../Screens/OrganisationAdmin/AddExpense'
import ManageExpense from '../../Screens/OrganisationAdmin/ManageExpense'
import CreateExpenseCategory from '../../Screens/OrganisationAdmin/CreateExpenseCategory'
import ManageExpenseCategory from '../../Screens/OrganisationAdmin/ManageExpenseCategory'
import AddSupplier from '../../Screens/OrganisationAdmin/AddSupplier'
import ManageSuppliers from '../../Screens/OrganisationAdmin/ManageSuppliers'
import Sales from '../../Screens/OrganisationAdmin/Sales'
import SetDiscounts from '../../Screens/OrganisationAdmin/SetDiscounts'
import ManageDiscounts from '../../Screens/OrganisationAdmin/ManageDiscounts'
import ExchangeRate from '../../Screens/OrganisationAdmin/ExchangeRate'
import AdminLayby from '../../Screens/OrganisationAdmin/AdminLayby'
import Reports from '../../Screens/OrganisationAdmin/Reports'
import ProfitnLoss from '../../Screens/OrganisationAdmin/ProfitnLoss'
import Profile from '../../Screens/OrganisationAdmin/Profile'

const Main = ({ activeScreen, isFirstLogin, screenParams }) => {
  const renderScreen = () => {
    // If first login, only allow profile screen
    if (isFirstLogin && activeScreen !== 'profile') {
      return <Profile />
    }

    switch (activeScreen) {
      case 'dashboard':
        return <Dashboard />
      case 'create-users':
        return <CreateUsers />
      case 'manage-users':
        return <ManageUsers />
      case 'access-logs':
        return <AccessLogs />
      case 'add-products':
        return <AddProducts />
      case 'manage-products':
        return <ManageProducts />
      case 'print-barcodes':
        return <PrintBarcodes />
      case 'import-from-excel':
        return <ImportFromExcel />
      case 'new-stock-entry':
        return <NewStockEntry />
      case 'manage-stocks':
        return <ManageStocks />
      case 'stock-adjustments':
        return <StockAdjustments />
      case 'stock-movement':
        return <StockMovement />
      case 'stock-movement-detail':
        return <StockMovementDetail movement={screenParams?.movement} />
      case 'return-to-warehouse':
        return <ReturntoWarehouse />
      case 'transfer-stocks':
        return <TransferStocks />
      case 'low-stock':
        return <LowStock />
      case 'add-categories':
        return <AddCategories />
      case 'manage-categories':
        return <ManageCategories />
      case 'add-unit':
        return <AddUnit />
      case 'manage-units':
        return <ManageUnits />
      case 'add-branch':
        return <AddBranch />
      case 'manage-branches':
        return <ManageBranches />
      case 'branch-stock':
        return <BranchStock branch={screenParams?.branch} />
      case 'add-warehouse':
        return <AddWarehouse />
      case 'manage-warehouses':
        return <ManageWarehouses />
      case 'add-expense':
        return <AddExpense />
      case 'manage-expenses':
        return <ManageExpense />
      case 'create-expense-category':
        return <CreateExpenseCategory />
      case 'manage-expense-category':
        return <ManageExpenseCategory />
      case 'add-supplier':
        return <AddSupplier />
      case 'manage-suppliers':
        return <ManageSuppliers />
      case 'sales':
        return <Sales />
      case 'set-discounts':
        return <SetDiscounts />
      case 'manage-discounts':
        return <ManageDiscounts />
      case 'exchange-rate':
        return <ExchangeRate />
      case 'admin-layby':
        return <AdminLayby />
      case 'reports':
        return <Reports />
      case 'profitnloss':
        return <ProfitnLoss />
      case 'profile':
        return <Profile />
      default:
        return <Dashboard />
    }
  }

  return (
    <main id="main" className="main">
      {renderScreen()}
    </main>
  )
}

export default Main
